import { NeoModel, ModelBase } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationEventLookup extends ModelBase {
    public organisationEventId: number = 0;

    public organisationId: number = 0;

    public staticEventId: number = 0;

    public organisationName: string = "";

    public staticEventName: string = "";
}